import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';
import Navbar from '../components/Navbar';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white">
      <Navbar />
      
      <div className="max-w-lg mx-auto px-4 py-16">
        <Card className="shadow-xl border-0">
          <CardContent className="p-8 text-center">
            <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-12 h-12 text-orange-600" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-neutral-900 mb-2">
              Payment Cancelled
            </h1>
            <p className="text-neutral-600 mb-6">
              Your payment was cancelled. No charges were made. You can try booking again whenever you're ready.
            </p>
            <div className="flex gap-4 justify-center">
              <Button onClick={() => navigate('/classes')} data-testid="browse-classes-btn">
                Browse Classes
              </Button>
              <Button variant="outline" onClick={() => navigate('/dashboard')}>
                Go to Dashboard
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancel;
